import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../../utils/responsive";

import img3 from "../../assets/Images/Home/pexels-ron-lach-9616964.jpg";
import img1 from "../../assets/Images/Home/Gemini_Generated_Image_osi2x3osi2x3osi2.jpg";
import img2 from "../../assets/Images/Home/KGM-106.jpg";

export default function Blogs() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [hoveredBlog, setHoveredBlog] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleKnowMore = () => {
    // window.open("/blog3", "_blank");
    console.log("clicked");
  };

  const BlogPanel = ({ index, image, number, title, description, to }) => (
    <div
      onMouseEnter={() => setHoveredBlog(index)}
      onMouseLeave={() => setHoveredBlog(null)}
      className="image-container"
      style={{
        height: isMobile ? "400px" : "690px",
        cursor: "pointer",
      }}
    >
      {/* Image */}
      <img
        className="image-cover-full-responsive"
        src={image}
        alt={`blog-${index}`}
        style={{
          transition: "transform 0.5s ease",
          transform: hoveredBlog === index ? "scale(1.05)" : "scale(1)",
        }}
      />

      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor:
            hoveredBlog === index ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.5)",
          transition: "all 0.5s ease",
        }}
      />

      {/* Text Overlay */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "10%",
          right: "10%",
          transform: `translateY(${hoveredBlog === index ? "-60%" : "-50%"})`,
          transition: "transform 0.5s ease",
          textAlign: "center",
          color: "white",
          fontFamily: "BodoniModa_18pt",
        }}
      >
        <div
          className="mb-3"
          style={{
            opacity: hoveredBlog === index ? 1 : 0.8,
            transition: "all 0.5s ease",
            transform:
              hoveredBlog === index ? "translateY(-10px)" : "translateY(0)",
          }}
        >
          <h3 className="heading-sm">{number}.</h3>
        </div>

        <div
          style={{
            opacity: hoveredBlog === index ? 1 : 0.8,
            transition: "all 0.5s ease",
            transform:
              hoveredBlog === index ? "translateY(-10px)" : "translateY(0)",
          }}
        >
          <h4 className="heading-sm m-0">{title}</h4>
        </div>

        <div
          style={{
            opacity: hoveredBlog === index ? 1 : 0.8,
            transition: "all 0.5s ease",
            transform:
              hoveredBlog === index ? "translateY(-10px)" : "translateY(0)",
            marginTop: "10px",
          }}
        >
          <p className="body-md">{description}</p>
        </div>

        <Button
          className="rounded-0 text-uppercase"
          variant="outline-light"
          style={{
            fontSize: isMobile ? "18px" : "28px",
            fontFamily: "BodoniModa_18pt",
            width: isMobile ? "100%" : "80%",
            transition: "all 0.5s ease",
            transform:
              hoveredBlog === index ? "translateY(-10px)" : "translateY(0)",
          }}
          onClick={() => navigate(to)}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "white";
            e.target.style.color = "black";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
          }}
        >
          READ MORE
        </Button>
      </div>
    </div>
  );

  return (
    <Container fluid className="p-0">
      {/* Heading Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
        )}
        {!isMobile && (
          <div
            style={{
              width: "30%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
        )}
        <div
          style={{
            width: isMobile ? "100%" : "30%",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0 text-center">BLOGS.</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "30%",
              borderBottom: "1px solid black",
            }}
          />
        )}
        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
            }}
          />
        )}
      </div>

      {/* Panel Row */}
      <div
        className="d-flex justify-content-center"
        style={{ flexDirection: isMobile ? "column" : "row" }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
        )}

        <div
          style={{
            width: isMobile ? "100%" : "45%",
            borderBottom: "1px solid black",
            padding: "0",
          }}
        >
          <BlogPanel
            index={1}
            image={img1}
            number="1"
            title="TIMELESS ELEGANCE, COLONIAL CHARM"
            description="A Victorian Colonial home blends the grandeur of Victorian-era design with the symmetry and practicality of Colonial architecture."
            to="/blog1"
          />
        </div>

        <div
          style={{
            width: isMobile ? "100%" : "45%",
            borderBottom: "1px solid black",
            padding: "0",
          }}
        >
          <BlogPanel
            index={2}
            image={img2}
            number="2"
            title="USE OF COLORS IN HOME INTERIORS"
            description="Paint can entirely change the atmosphere of the interior and create harmony with the décor by your style. Each tone of color.."
            to="/blog2"
          />
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
            }}
          />
        )}
      </div>
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-right-black border-bottom-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "45%",
            }}
          ></div>
        )}
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "100%" : "45%",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0">ARCHIVE.</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>

      {/* Main Content Row */}
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}

        {/* Image Column */}
        <div
          className={`image-container border-bottom-black ${
            !isMobile && "border-right-black"
          }`}
          style={{
            width: isMobile ? "100%" : "45%",
            padding: "0",
            overflow: "hidden",
            minHeight: isMobile ? "400px" : "600px",
            position: "relative",
          }}
        >
          <img
            className="image-cover-full-responsive"
            src={img3}
            alt="Profile 1"
            style={{
              transition: "transform 0.5s ease-in-out",
              transform: isHovered ? "scale(1.05)" : "scale(1)",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </div>

        {/* Text Column */}
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "100%" : "45%",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg">
              A space where deisgn meets storytelling. Our blogs bring insight
              into exploring timeless design principles, styling ideas,
              furniture know hows.
            </p>
            <p className="body-lg accent-text mt-4">
              Explore. Learn. Get Inspired
            </p>
          </div>
          <div
            style={{
              padding: isMobile ? "20px 40px" : "0 80px 40px",
            }}
          >
            <Button
              className="rounded-0 text-uppercase"
              variant="outline-dark"
              style={{
                fontSize: isMobile ? "18px" : "28px",
                fontFamily: "BodoniModa_18pt",
                width: isMobile ? "100%" : "75%",
                transition: "all 0.3s ease-in-out",
                position: "relative",
                overflow: "hidden",
                zIndex: 1,
              }}
              onClick={handleKnowMore}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#000";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#000";
              }}
            >
              Know More
            </Button>
          </div>
        </div>

        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
